import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from '@/components/ConfirmDialog';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const ConfirmCloseDialog = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation('entryModal', {
    keyPrefix: 'confirm_close_dialog',
  });

  return (
    <ConfirmDialog
      cancelButtonText={null}
      confirmButtonText={t('action')}
      isOpen={isOpen}
      message={t('message')}
      title={t('title')}
      onCancel={onClose}
      onConfirm={onClose}
    />
  );
};
